export default {
  'app.setting.pagestyle': 'Page style setting',
  'app.setting.pagestyle.light': 'Light style',
  'app.setting.pagestyle.dark': 'Dark style',
  'app.setting.pagestyle.realdark': 'RealDark style',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.content-width': 'Content Width',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.multitab': 'View multitab',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Weak Mode',
  'app.setting.copy': 'Copy Setting',
  'app.setting.loading': 'Loading theme',
  'app.setting.copyinfo': 'copy success，please replace defaultSettings in src/config/defaultSettings.js',
  'app.setting.production.hint': 'Setting panel shows in development environment only, please manually modify',
  'app.setting.themecolor.daybreak': 'Daybreak Blue',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polar Green',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Golden Purple',

  '系统用户': {
    '开始时间': 'start time',
    '结束时间': 'end time',
  },

  '被引用次数': 'Reference Count',

  '入驻时长': {
    '入驻时长（年）': 'Entry Duration (Years)',
    '入驻时长已存在': 'The entry duration already exists',
  },


  '云种植公告': {
    '公告标题': 'Title',
    '封面图': 'Cover Image',
    '简介': 'Summary',
    '公告时间': 'Notice Time',
    '内容': 'Content',
    '状态': 'Status',
    '排序': 'Sort',
    '排序提示': 'Higher number means higher priority',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '云种植气候': {
    '气候名称': 'Climate Name',
    '封面图': 'Climate Icon',
    '气候描述': 'Climate Description',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '云种植种子': {
    '种子名称': 'Seed Name',
    '种子图片': 'Seed Image',
    '种子描述': 'Seed Description',
    '生长周期': 'Growth Cycle(Days)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '监控配置': {
    '监控名称': 'Monitor Name',
    '监控地址': 'Monitor URL',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '土地管理': {
    '土地名称': 'Land Name',
    '土地图片': 'Land Image',
    '气候': 'Climate',
    '监控配置': 'Monitor',
    '面积': 'Area(㎡)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '土地面积价格': {
    '面积': 'Area(㎡)',
    '价格': 'Price(Yuan)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '土地时效价格': {
    '时长': 'Duration(Days)',
    '价格': 'Price(Yuan)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '监控时效价格': {
    '时长': 'Duration(Days)',
    '价格': 'Price(Yuan)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '操作价格': {
    '操作名称': 'Operation Name',
    '操作图标': 'Operation Icon',
    '价格': 'Price(Yuan)',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '操作次数': {
    '土地': 'Land',
    '操作': 'Operation',
    '总次数': 'Total Count',
    '剩余次数': 'Remaining Count',
    '创建时间': 'Create Time',
  },
  '操作记录': {
    '土地': 'Land',
    '操作': 'Operation',
    '操作时间': 'Operation Time',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '种植记录': {
    '土地': 'Land',
    '种子': 'Seed',
    '种植时间': 'Plant Time',
    '状态': 'Status',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '邮寄申请': {
    '用户': 'User',
    '种子': 'Seed',
    '气候': 'Climate',
    '申请状态': 'Apply Status',
    '申请时间': 'Apply Time',
    '审核时间': 'Audit Time',
    '审核备注': 'Audit Remark',
    '发货状态': 'Delivery Status',
    '发货时间': 'Delivery Time',
    '物流单号': 'Tracking Number',
    '创建时间': 'Create Time',
  },
  '种子仓库': {
    '用户': 'User',
    '种子': 'Seed',
    '土地': 'Land',
    '平台确认': 'Platform Confirmed',
    '已确认': 'Confirmed',
    '未确认': 'Unconfirmed',
    '是否已种植': 'Planted',
    '已种植': 'Planted',
    '未种植': 'Unplanted',
    '状态': 'Status',
    '获得时间': 'Gain Time',
    '创建时间': 'Create Time',
  },
  '平台地址': {
    '联系人': 'Contact Person',
    '联系电话': 'Contact Phone',
    '省份': 'Province',
    '城市': 'City',
    '区县': 'District',
    '详细地址': 'Detail Address',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '通用': {
    '按钮': {
      '新增': 'Add',
      '确定': 'Ok',
      '审核': 'audit',
      '修改': 'edit',
      '复制': 'copy',
      '删除': 'remove',
      '关闭': 'remove',
      '导出': 'export',
      '选中导出': 'select export',
      '导入': 'import',
      '查询': 'query',
      '重置': 'reset',
      '详情': 'info',
      '上传': 'upload',
      '展开': 'Expand',
      '收起': 'Stow',
      '更多': 'more',
      '保存': 'save',
      '取消': 'cancel',
      '保存并离开': 'Save & Leave',
      '不保存': 'Don\'t Save',
      '翻译': 'translation',
      '刷新缓存': 'flush cache',
    },
    '输入': {
      '请输入': 'please enter ',
      '请选择': 'please select ',
    },
    '文本': {
      '是': 'yes',
      '否': 'no',
      '启用': 'enable',
      '禁用': 'disable',
      '操作': 'Operation',
      '添加': 'add',
      '创建时间': 'create time',
      '排序': 'sort',
      '修改': 'edit',
      '确认删除所选中数据': 'Confirm deletion of selected data?',
      '删除成功': 'remove success',
      '确认取消': 'confirm cancel?',
      '取消成功': 'cancel success',
      '新增成功': 'add success',
      '修改成功': 'edit success',
      '上传成功': 'upload success',
      '导出成功': 'export success',
      '共': 'total ',
      '条': ' record',
      '默认': 'default',
      '中等': 'medium',
      '紧凑': 'compact',
      '多语言配置': 'multi-Language configuration',
      '列展示排序': 'column display/sort',
      '列排序需拖动名称': 'Column sorting requires dragging name',
      '不能为空': ' not be empty',
      '格式错误': ' format error',
      '不能小于0': 'not be zero',
      '语言': 'Language',
      '根节点': 'root',
      '创建开始时间': 'create start time',
      '创建结束时间': 'create end time',
      '是否确认导出': 'Confirm Export?',
      '确认提交': 'Confirm Submit?',
      '离开确认': 'Leave Confirm',
      '未保存离开提示': 'The current changes are not saved. Save before leaving?',
      '此操作将导出当前条件下所有数据而非选中数据': 'This will export all data under the current condition instead of the selected data',
      '此操作将导出选中数据': 'This will export the selected data',
    },
  },
  '广告': {
    '位置': 'position',
    '跳转类型': 'jump type',
    '广告名称': 'name',
    '开始时间': 'start time',
    '结束时间': 'end time',
    '选择申请': 'select apply',
    '外链': 'outlink',
    '内容详情': 'info',
    '是否隐藏': 'is hidden',
    '展示时长': 'show times',
    '展示次数': 'show num',
    '点击次数': 'click num',
    '跳转次数': 'jump num',
    '封面图': 'cover img',
    '详情图': 'detail img',
    '选择上门服务': 'select home service',
    '选择上门服务公告': 'select home service notice',
    '选择商城头条': 'select mall headline',
    '选择云种植公告': 'select cloud plant notice',
    '选择店铺': 'select shop',
    '店铺名称': 'Shop Name',
  },

  '商品分类': {
    '商品分类': 'category',
    '分类名称': 'category name',
    '分类图片': 'category pic',
    '上级分类': 'parent',
    '分类等级': 'level',
    '是否显示': 'is visible',
    '是否首页展示': 'is home visible',
    '是否参与筛选': 'is filter',
    '创建时间': 'create time',
  },
  '商品标签':{
    '标签名称':'label name',
    '图标':'icon',
    '颜色':'color',
    '状态':'status',
    '创建时间':'create time',
    '更新时间':'update time',
    '备注':'remark',
  },
  '商品': {
    '批量上架': 'batch on sale',
    '标签': 'label',
    '售卖区域': 'prod area',
    '批量下架': 'batch off sale',
    '批量复制': 'batch copy',
    '确认复制': 'confirm copy?',
    '复制成功': 'copy success',
    '选择明星': 'select star',
    '选择运费模板': 'select Freight template',
    '基础信息': 'Basic information',
    '标签信息': 'label information',
    '规格信息': 'Spec Information',
    '详情信息': 'goods info',
    '上架成功': 'on sale success',
    '下架成功': 'off sale success',
    '确认上架': 'confirm on sale?',
    '确认下架': 'confirm off sale?',
    '确认保存商品信息': 'Confirm to save this product information?',
    '添加规格': 'add specification',
    '修改规格': 'edit specification',
    '商品类型': 'goods type',
    '商品': 'goods',
    '明星': 'star',
    '限购数': 'min buy num',
    '售卖开始时间': 'sale start time',
    '售卖结束时间': 'sale end time',
    '是否多规格': 'is multiple spec',
    '是否允许合并购买': 'is allow Merger Purchase',
    '商品颜色': 'color',
    '商品详情': 'goods info',
    '温馨提示': 'Warm Tip',
    '市场价': 'market price',
    '成本价': 'cost price',
    '虚拟销量': 'virtual Sales num',
    '是否展示销量': 'is show sales num',
    '商品价': 'price',
    '商品编号': 'goods code',
    'SKU编号': 'sku code',
    'SKU名字': 'sku name',
    '规格名称': 'spec name',
    '商品名称': 'goods name',
    '商品重量': 'weight',
    '包装单位': 'unit',
    '商品主图': 'master picture',
    '商品轮播图': 'carousel graph',
    '商品分类': 'goods category',
    '商品关键词': 'keyword',
    '品牌': 'brand',
    '运费模板': 'Freight template',
    '商品价格': 'price',
    '自购返金额': 'self purchase rebate',
    '活动价格': 'activity price',
    '秒杀价格': 'seckill price',
    '团购价格': 'group price',
    '会员价格': 'member price',
    '限购数量': 'max buy num',
    '商品库存': 'stock',
    '预警库存': '预警库存',
    '商品状态': 'goods status',
    '实际销量': 'sales num',
    '售卖范围': '售卖范围',
    '是否推荐': 'is_recommend',
    '是否新品': 'is new',
    '是否样品': '是否样品',
    '是否日历展示': 'is show calendar',
    '是否精品': '是否精品',
    '是否免费领': '是否免费领',
    '是否限购': 'is max buy',
    '是否爆款': '是否爆款',
    '售后方式': 'refund type',
    '创建时间': 'create time',
    '规格': {
      '添加规格值': 'add spec value',
      '规格名称': 'spec name',
      '规格值': 'spec value',
      '是否可见': 'is show',
      '规格图片': 'spec picture',
      '是否有规格图片': 'is have picture',
    },
    'sku': {
      '名称': 'sku name',
      '编码': 'sku code',
      '价格': 'sku price',
      '活动价格': 'sku activity price',
      '库存': 'stock',
      '重量': 'weight',
      '图片': 'sku picture',
    },
  },
  '品牌': {
    '品牌名称': 'brand name',
    '品牌备注': 'remark',
    '品牌首字母': 'first word',
    'logo': 'logo',
    '创建时间': 'create time',
  },
  '明星分类': {
    '分类名称': 'category',
    '是否显示': 'is show',
    '创建时间': 'create time',
    '备注': 'remark',
  },
  '明星': {
    '明星名字': 'star name',
    '明星分类': 'category',
    '明星照片': 'star picture',
    '背景图': 'Background picture',
    '基础粉丝数': 'fans num',
    '网址': 'web url',
    '状态': 'status',
    '关注数': 'focus num',
    '明星介绍': 'info',
    '创建时间': 'create time',
    '备注': 'remark',
  },
  '明星俱乐部': {
    '俱乐部名字': 'club name',
    '商品数': 'goods num',
    '创建时间': 'create time',
    '备注': 'remark',
  },

  '活动分类':{
    '分类名称':'cate name',
    '状态':'status',
    '排序':'sort',
    '创建者':'创建者',
    '创建时间':'create time',
    '更新时间':'update time',
    '备注':'remark',
  },
  '活动记录': {
    '活动ID':'activity id',
    '商品最大购买数量':'max buy num',
    '选择活动':'select activity',
    '排行':'rank',
    '是否上架':'is onsale',
    '活动类型':'activity type',
    '活动名称':'activity name',
    '开始时间':'start time',
    '结束时间':'end time',
    '活动封面图':'cover picture',
    '分享海报图':'poster picture',
    '分享文案':'poster text',
    '限制会员等级':'限制会员等级',
    '最多参与次数':'Maximum',
    '活动详情':'activity info',
    '状态':'status',
    '是否展示到日历':'is show calendar',
    '创建时间':'create time',
    '活动参与区域':'活动参与区域'
  },
  '运费模板': {
    '计费方式':'计费方式'
  },
  '收货地址': {
    '应援地址':'应援地址',
    '收货区域':'收货区域',
    '收货人手机号':'收货人手机号',

  },
  '广告投放审核': {
    '联系电话': 'Contact Phone',
    '广告名称': 'Advertisement Name',
    '广告简介': 'Advertising Introduction',
    '广告活动开始时间': 'start time',
    '广告活动结束时间': 'end time',
    '审核状态': 'audit status',
    '审核时间': 'audit time',
    '姓名': 'name',
    '创建时间':'create time',
    '原因': 'reason',
    '是否通过': 'is pass',

  },
  '订单取消原因': {
    '名称':'Name',
    '类型':'type',
    '用途类型':'Use Type',
    '创建时间':'create time',
    '是否显示':'is show',
  },

  '等级设置': {
    '会员等级名称': 'Level Name',
    '等级图片': 'level picture',
    '等级图标': 'icon',
    '会员等级排序': 'sort',
    '升级所需代币': 'upgrade score',
  },
  '商品足迹': {
    '商品名称': 'goods name',
    '商品主图': 'picture',
    '排序': 'sort',
    '搜索次数': 'search num',
    '创建时间': 'create time',
  },
  '订单发货记录': {
    '发货方式': 'delivery type',
    '发货人手机号': 'delivery mobile',
    '发货时间': 'delivery time',
    '发货记录编号': 'delivery id',
    '发货开始时间': 'delivery start time',
    '发货结束时间': 'delivery end time',


  },

  '销售订单': {
    '全部订单': 'all',
    '此操作将导出当所有待发货订单而非选中数据':'This will export the data when all pending orders are not selected',
    '导出待发货':'Export to be shipped',
    '导入发货单':'Import Shipment Doc',
    '接单':'orders',
    '接单成功':'orders success',
    '物流公司':'Import Shipment Doc',
    '物流单号':'Logistics document number',
    '物流详情':'Logistics Details',
    '寄件人手机号':'Sender Mobile Number',
    '订单编号':'Order Number',
    '订单来源':'Order Source',
    '直播间名称':'Live Room Name',
    '普通购买':'Normal Purchase',
    '直播间购买':'Live Room Purchase',
    '订单类型':'Order type',
    '订单数量':'Order Quantity',
    '订单信息':'Order Information',
    '订单详情':'Order Details',
    '三方订单号':'Tripartite Order Number',
    '买家名称':'Buyer Name',
    '买家信息':'Buyer Information',
    '手机号或邮箱':'phone or email',
    '订单状态':'Order Status',
    '下单时间':'Order time',
    '下单开始时间':'下单开始时间',
    '下单结束时间':'下单结束时间',
    '支付方式':'Payment Method',
    '支付时间':'Payment time',
    '退款状态':'退款状态',
    '商品数量':'Quantity of goods',
    '商品金额':'Commodity amount',
    '商品实付金额':'pay amount',
    '优惠金额':'discount amount',
    '订单金额':'Order Amount',
    '运费金额':'Freight amount',
    '运费实付':'Freight paid',
    '用户备注':'User Notes',
    '商品信息':'Commodity Information',
    '活动信息':'Activity Information',
    '收货地址信息':'Receiving address information',
    '实付单价':'Actual unit price',
    '数量':'Quantity',
    '收货人姓名':'Receiver Name',
    '性别':'sex',
    '手机号':'mobile',
    '邮箱':'email',
    '地址类型':'address type',
    '地区':'nation',
    '详细地址':'address detail',
    '发货':'receive',
    '发货成功':'success',
    '取消订单':'cancel',
    '发货备注':'remark',

    '订单原价':'Original order price',
    '实付金额':'Actual amount paid',
    '运费':'Freight',
    '是否首单':'is first order',
    '是否催发货':'is remind',

  },
  '售后订单': {
    '原订单编号': 'Original Order Number',
    '售后单编号': 'After-sales order number',
    '售后类型': 'After-sales type',
    '售后状态': 'After-sales status',
    '售后凭证': 'After-sales Voucher',
    '购买数量': 'Purchase Quantity',
    '售后数量': 'After-sales quantity',
    '申请开始时间':'Application start time',
    '申请结束时间':'Application end time',
    '退款金额': 'Refund amount',
    '申请时间': 'Application time',
    '售后原因': 'After-sales reasons',
    '售后信息': 'After-sales information',
    '原订单信息': 'Original Order Information',
    '订单详情':'Order Details',
    '售后详情':'After-sales details',
    '售后商品':'After-sale goods',
    '备注':'Remarks',
    '审核':'审核',
    '是否同意':'是否同意',
    '拒绝原因':'拒绝原因',
    '审核成功':'审核成功',
    '退款': 'refund',
    '是否确认退款': 'is refund',
    '退款成功': 'refund success',

  },

  '用户': {
    '发送消息':'send message',
    '手机号':'mobile',
    '联系方式':'Contact Information',
    '用户等级':'level',
    '代币':'score',
    '邮箱':'email',
    '昵称':'nick name',
    '头像':'avatar',
    '微信':'wechat',
    '真实姓名':'real name',
    '身份证':'idcard',
    '性别':'sex',
    '生日':'Birthday',
    '邀请码':'邀请码',
    '注册时间':'create time',
    '开始时间':'Start Time',
    '结束时间':'End Time',
    '用户状态':'status',
    '当日活跃时长':'Today Active Duration(min)',
    '青少年模式':'Teen Mode',
    '已开启':'Enabled',
    '未开启':'Disabled',
    '关闭青少年模式':'Close Teen Mode',
    '确认关闭青少年模式':'Are you sure to close teen mode for this user?',
    '关闭青少年模式成功':'Teen mode closed successfully',
  },

  '用户代币变动记录':{
    '订单编号':'orderNo',
    '备注':'remark',
    '变动的代币数':'score',
    '变动前剩余代币':'before score',
    '变动后剩余代币':'after score',
  },

  '用户注销': {
    '注销原因':'cancel reason',
    '审核状态':'Audit Status',
    '审核失败原因':'Failure Reason',
    '审核人':'Reviewer',
    '审核时间':'Review time',
    '注销时间':'Logout time',
  },

  '用户搜索记录': {
    '类型':'type',
    '搜索内容':'Search Content',
    '搜索次数':'Number of searches',
    '创建时间':'create time',

  },

  '意见反馈': {
    '用户':'user',
    '备注':'remark',
    '处理状态':'status',
    '联系方式':'Contact',
    '反馈图片':'picture',
    '处理':'Process',
    '反馈类型':'type',
    '反馈内容':'content',
    '处理结果':'result',
    '创建时间':'create time',
  },

  '物流公司信息': {
    '编号': 'id',
    '公司名称': 'Company Name',
    '公司编码': 'Company Code',
    '公司类型': 'Company Type',
    '公司logo': 'logo',
    '是否选用': 'Whether selected',
    '排序': 'sort',
    '备注': 'remark',

  },
  '报表': {
    '商品': {
      '订单开始时间': 'start time',
      '订单结束时间': 'end time',
      '点击量': 'clicks num',
      '收藏量': 'collection num',
      '订单量': 'order count',
      '商品销量': 'sales num',
      '加购量': 'cart num',
      '商品销售额': 'goods amount',
      '订单销售金额': 'order amount',
      '销售金额': 'pay amount',
      '销售占比': 'pay amount rate',
      '退款占比': 'refund amount rate',
      '退款金额': 'refund amount',
      '退款单数': 'refund order count',
      '退款量': 'refund_num',
    },
    '用户': {
      '注册开始时间': 'start time',
      '注册结束时间': 'end time',
      '支付金额': 'pay amount',
      '最后下单时间': 'last order time',
      '购买商品量': 'goods count',
    },
  },

  '商品对账单': {
    '账单日期': 'bill date',
    '账单月份': 'bill month',
  },

  '交易单':{
    '交易单号':'trade no',
    '订单编号':'order no',
    '订单类型':'order type',
    'ip':'ip',
    '支付方式':'pay type',
    '交易类型':'trade type',
    '支付金额':'pay amount',
    '账期金额':'账期金额',
    '手续费':'fee',
    '支付信息':'支付信息',
    '三方订单号':'out trade no',
    '三方支付流水号':'out pay no',
    '支付状态': 'pay status',
    '交易完成时间':'pay time',
    '创建时间':'create time',
    '过期时间':'expire time',
    '备注':'remark',
  },
  '常见问题':{
    '常见问题标题':'常见问题标题',
    '常见问题简述':'常见问题简述',
    '问题分类':'问题分类',
    '常见问题内容':'常见问题内容',
    '内容类型':'Content Type',
    '富文本':'Rich Text',
    'PDF':'PDF',
    '显示顺序':'显示顺序',
    '状态':'状态',
    '备注':'备注',
    '创建人':'创建人',
    '插入时间':'插入时间',
    '修改人':'修改人',
    '修改时间':'修改时间',
    '版本号':'版本号',
  },
  '常见问题分类':{
    '主图':'主图',
    '标题':'标题',
    '显示顺序':'显示顺序',
    '备注':'备注',
    '创建人':'创建人',
    '插入时间':'插入时间',
    '修改人':'修改人',
    '修改时间':'修改时间',
    '版本号':'版本号',
  },
  '预售活动商品配置':{
    'id':'id',
    '店铺id':'shop id',
    '活动名称':'activity name',
    '活动开始时间':'activity start time',
    '活动结束时间':'activity end time',
    '商品id':'goods id',
    '商品名称':'goods name',
    '商品图片':'goods picture',
    '商品原价':'goods price',
    '预售商品售卖价格':'presale price',
    '支付定金价格':'deposit price',
    '支付尾款价格(预售商品售卖价格-支付定金价格)':'balance price',
    '审核状态  1:待审核 2:审核未通过 3:审核通过 4:活动已结束（活动已结束后就不能再开始啦需要重新添加活动、商品下架后活动也会结束）':'audit status',
    '审核意见':'audit opinion',
    '总完成数量':'total count',
    '尾款付款开始时间':'balance payment start time',
    '创建者':'creator',
    '创建时间':'create time',
    '修改人':'modifier',
    '更新时间':'update time',
    '逻辑删除标记':'is deleted',
    '租户ID，外键{tenant.id}':'tenant id',
    '备注':'remark',
    '版本号':'version',
    '流程说明':'process description',
    'SKU预售价格设置':'SKU Presale Price Setting',
    'SKU名称':'SKU Name',
    'SKU图片':'SKU Picture',
    '原价':'Original Price',
    '库存':'Stock',
    '预售价格':'Presale Price',
    '活动开始时间不能早于当前时间':'The activity start time cannot be earlier than the current time',
    '活动结束时间不能早于当前时间':'The activity end time cannot be earlier than the current time',
    '活动结束时间不能早于开始时间':'The activity end time cannot be earlier than the start time',
    '尾款付款开始时间不能早于当前时间':'The balance payment start time cannot be earlier than the current time',
  },
  '拼团活动商品':{
    '主键id':'id',
    '店铺id':'shop id',
    '商品id':'goods id',
    '活动名称':'activity name',
    '拼团有效期':'group valid time(hour)',
    '发起拼团额外付的钱':'extra pay money',
    '成团人数':'group number',
    '商品名称':'goods name',
    '拼团价格':'group price',
    '原价':'original price',
    '商品图片':'goods picture',
    '状态':'status',
    '拒绝原因':'reject reason',
    '拼团开始时间':'group start time',
    '拼团结束时间':'group end time',
    '最大购买数量':'max buy count',
    '完成拼团数量':'complete count',
    '总团数量':'total group count',
    '创建者':'creator',
    '创建时间':'create time',
    '修改人':'modifier',
    '更新时间':'update time',
    '逻辑删除标记':'is deleted',
    '租户ID':'tenant id',
    '备注':'remark',
    '版本号':'version',
    'SKU拼团价格设置':'SKU Group Price Setting',
    'SKU名称':'SKU Name',
    'SKU图片':'SKU Picture',
    '库存':'Stock',
  },
  '砍价活动配置':{
    '活动开始时间不能早于当前时间':'The activity start time cannot be earlier than the current time',
    '活动结束时间不能早于当前时间':'The activity end time cannot be earlier than the current time',
    '活动结束时间不能早于开始时间':'The activity end time cannot be earlier than the start time',
  },
  '特价活动商品':{
    '主键id':'id',
    '店铺id':'shop id',
    '商品id':'goods id',
    '活动名称':'activity name',
    '商品名称':'goods name',
    '特价价格':'special price',
    '原价':'original price',
    '商品图片':'goods picture',
    '状态':'status',
    '拒绝原因':'reject reason',
    '创建者':'creator',
    '创建时间':'create time',
    '修改人':'modifier',
    '更新时间':'update time',
    '逻辑删除标记':'is deleted',
    '租户ID，外键{tenant.id}':'tenant id',
    '备注':'remark',
    '版本号':'version',
    'SKU特价设置':'SKU Special Price Setting',
    'SKU名称':'SKU Name',
    'SKU图片':'SKU Picture',
    '库存':'Stock',
    '特价':'Special Price',
  },
  '秒杀库存':{
    'id':'id',
    '时间轴id':'seckill time id',
    '商品id':'goods id',
    '商品名称':'goods name',
    '秒杀价格':'seckill price',
    '商品现价':'goods price',
    '已经秒杀数量':'seckill num',
    '商品图片':'goods picture',
    '秒杀商品库存':'stock',
    '店铺id':'shop id',
    '店铺名字':'shop name',
    '状态':'status',
    '秒杀是否完成':'complete',
    '拒绝原因':'reject reason',
    '秒杀开始时间':'seckill start time',
    '秒杀结束时间':'seckill end time',
    '最大购买数量':'max buy count',
    '创建时间':'create time',
    '修改时间':'update time',
    '创建人':'creator',
    '修改人':'modifier',
    '备注':'remark',
    'SKU秒杀价格设置':'SKU Seckill Price Setting',
    'SKU名称':'SKU Name',
    'SKU图片':'SKU Picture',
    '原价':'Original Price',
    '库存':'Stock',
  },
  '上门服务公告': {
    '公告标题': 'Title',
    '公告简介': 'Summary',
    '公告内容': 'Content',
    '分类': 'Category',
    '用户端': 'User',
    '师傅端': 'Master',
    '排序': 'Sort',
    '排序提示': 'Higher number means higher priority',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '上门服务分类': {
    '分类名称': 'Category Name',
    '父级分类': 'Parent Category',
    '分类级别': 'Category Level',
    '一级分类': 'Primary Category',
    '二级分类': 'Secondary Category',
    '分类图标': 'Category Icon',
    '是否首页展示': 'Home Visible',
    '排序': 'Sort',
    '排序提示': 'Higher number means higher priority',
    '备注': 'Remark',
    '创建时间': 'Create Time',
    '添加子分类': 'Add Sub Category',
    '新增一级分类': 'Add Primary Category',
    '新增二级分类': 'Add Secondary Category',
    '修改分类': 'Edit Category',
    '确认删除分类': 'Confirm to delete this category?',
  },
  '上门服务': {
    '服务名称': 'Service Name',
    '服务简介': 'Service Intro',
    '服务编号': 'Service ID',
    '服务主图': 'Service Picture',
    '归属城市': 'Cities',
    '归属城市提示': 'Multiple cities selectable, nationwide by default',
    '全国': 'Nationwide',
    '服务轮播图': 'Service Images',
    '服务详情': 'Service Detail',
    '服务价格': 'Service Price',
    '价格单位': 'Price Unit',
    '服务分类': 'Service Category',
    '是否推荐': 'Is Recommend',
    '是否热搜': 'Is Hot',
    '状态': 'Status',
    '排序': 'Sort',
    '备注': 'Remark',
    '创建时间': 'Create Time',
    '服务项目': 'Service Items',
    '添加项目': 'Add Item',
    '项目名称': 'Item Name',
    '项目价格': 'Item Price',
    '服务项目至少一条': 'At least one service item is required',
    '服务': 'Service',
    '选择服务': 'Select Service',
  },
  '商城头条': {
    '标题': 'Title',
    '封面图': 'Cover Image',
    '富文本详情': 'Content',
    '发布时间': 'Publish Time',
    '是否首页展示': 'Home Visible',
    '排序': 'Sort',
    '所属分类': 'Category',
    '备注': 'Remark',
    '创建时间': 'Create Time',
  },
  '废品服务': {
    '扔垃圾服务配置': 'Garbage Service Config',
    '收废品服务配置': 'Waste Recycling Config',
    '服务名称': 'Service Name',
    '服务说明': 'Service Intro',
    '服务封面图': 'Service Cover',
    '服务价格': 'Service Price',
    '服务介绍': 'Service Images',
    '服务标准': 'Service Standard',
    '备注': 'Remark',
  },
  '技能管理': {
    '技能名称': 'Skill Name',
    '技能图标': 'Skill Icon',
    '技能类型': 'Skill Type',
    '通用技能': 'General Skill',
    '废品技能': 'Waste Skill',
    '排序': 'Sort',
    '状态': 'Status',
    '备注': 'Remark',
    '新增技能': 'Add Skill',
    '修改技能': 'Edit Skill',
    '创建时间': 'Create Time',
  },
  '入驻审核': {
    '角色类型': 'Role Type',
    '头像': 'Avatar',
    '姓名': 'Name',
    '联系方式': 'Mobile',
    '地区': 'Region',
    '照片': 'Photo',
    '审核状态': 'Audit Status',
    '保证金状态': 'Deposit Status',
    '工作状态': 'Work Status',
    '创建时间': 'Create Time',
    '详情': 'Detail',
    'APP用户手机号': 'App User Mobile',
    'APP用户昵称': 'App User NickName',
    '地址': 'Address',
    '身份证号码': 'ID Card',
    '从业时间': 'Work Start Time',
    '身份证人面像': 'ID Card Front',
    '身份证国徽面': 'ID Card Back',
    '手持身份证': 'ID Card Hand',
    '已缴纳保证金': 'Deposit Amount',
    '账户余额': 'Balance',
    '服务评价': 'Rating',
    '接单数量': 'Order Count',
    '后台账号ID': 'Sys User ID',
    '后台账号名': 'Sys User Name',
    '社区审核列表': 'Community List',
    '审核备注': 'Audit Remark',
    '审核时间': 'Audit Time',
    '审核结果': 'Audit Result',
    '审核详情': 'Audit Detail',
    '个人介绍': 'Introduction',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '通过': 'pass',
    '拒绝': 'fail',
    '备注': 'remark',
    '修改审核': 'Change Audit',
    '请选择审核结果': 'Please select audit result',
    '请输入审核备注': 'Please enter audit remark',
    '请输入拒绝原因': 'Please enter reject reason',
  },
  '敏感内容日志': {
    '用户ID': 'User ID',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '用户IP': 'User IP',
    '命中类型': 'Hit Type',
    '文本': 'Text',
    '图片': 'Image',
    '业务场景': 'Biz Type',
    '敏感内容': 'Sensitive Content',
    '敏感文字内容': 'Sensitive Text',
    '违规图片': 'Illegal Image',
    '查看违规图片': 'View Illegal Image',
    '图片预览': 'Image Preview',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '创建时间': 'Create Time',
    '日志详情': 'Log Detail',
  },
  '社区账单': {
    '社区名称': 'Community Name',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '用户昵称': 'User Nickname',
    '手机号': 'Mobile',
    '房间号': 'Room Number',
    '账单类型': 'Bill Type',
    '账单年月': 'Bill Month',
    '账单金额': 'Total Fee',
    '支付状态': 'Pay Status',
    '创建时间': 'Create Time',
    '选择社区': 'Select Community',
    '选择业主房号': 'Select Owner Room',
    '选择房间': 'Select Room',
    '水费': 'Water Fee',
    '水费金额': 'Water Amount',
    '水费账单图片': 'Water Bill Image',
    '电费': 'Electric Fee',
    '电费金额': 'Electric Amount',
    '电费账单图片': 'Electric Bill Image',
    '燃气费': 'Gas Fee',
    '燃气费金额': 'Gas Amount',
    '燃气费账单图片': 'Gas Bill Image',
    '物业费': 'Property Fee',
    '物业费每月': 'Property Fee/Month',
    '缴纳月数': 'Months',
    '账单总金额': 'Total Amount',
    '备注': 'Remark',
    '请选择房间': 'This user has rooms, please select a room',
    '用户无房间': 'This user has no room, cannot submit bill',
  },
  '服务订单': {
    '服务订单': 'Service Order',
    '订单编号': 'Order No',
    '订单类型': 'Order Type',
    '服务类型': 'Service Type',
    '订单状态': 'Order Status',
    '服务主图': 'Service Picture',
    '服务名称': 'Service Name',
    '服务项目名称': 'Service Item Name',
    '联系人姓名': 'Contact Name',
    '联系人电话': 'Contact Phone',
    '服务完成备注': 'Finish Remark',
    '实付金额': 'Pay Amount',
    '优惠金额': 'Discount Amount',
    '订单原价': 'Original Amount',
    '加价状态': 'Add Price Status',
    '有加价': 'Has Add Price',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '预约时间': 'Service Time',
    '预约服务时间': 'Service Time Range',
    '创建时间': 'Create Time',
    '订单详情': 'Order Detail',
    '基本信息': 'Basic Info',
    '服务信息': 'Service Info',
    '用户信息': 'User Info',
    '接单方信息': 'Acceptor Info',
    '加价信息': 'Add Price Info',
    '完成信息': 'Complete Info',
    '评价信息': 'Rating Info',
    '取消信息': 'Cancel Info',
    '金额信息': 'Amount Info',
    '支付方式': 'Pay Type',
    '支付时间': 'Pay Time',
    '是否使用优惠券': 'Use Coupon',
    '是': 'Yes',
    '否': 'No',
    '优惠券名称': 'Coupon Name',
    '用户昵称': 'Nickname',
    '用户手机号': 'Mobile',
    '服务地址': 'Service Address',
    '服务房间号': 'Room Number',
    '服务业主名': 'Owner Name',
    '服务业主电话': 'Owner Phone',
    '用户备注': 'User Remark',
    '用户备注图片': 'User Remark Images',
    '接单方类型': 'Acceptor Type',
    '接单方名称': 'Acceptor Name',
    '接单方头像': 'Acceptor Avatar',
    '接单方电话': 'Acceptor Phone',
    '接单方星级': 'Acceptor Rating',
    '接单时间': 'Accept Time',
    '开始上门时间': 'Start Service Time',
    '加价金额': 'Add Price Amount',
    '加价备注': 'Add Price Remark',
    '加价图片': 'Add Price Images',
    '完成时间': 'Finish Time',
    '服务完成图片': 'Finish Images',
    '评价星级': 'Rating',
    '评价时间': 'Rating Time',
    '评价内容': 'Comment',
    '取消方': 'Cancel By',
    '取消时间': 'Cancel Time',
    '取消原因': 'Cancel Reason',
    '指定师傅': 'Assign Worker',
    '选择师傅': 'Select Worker',
    '接单量': 'Order Count',
    '请选择师傅': 'Please select a worker',
    '上门服务': 'Home Service',
    '废品服务': 'Waste Service',
    '扔垃圾': 'Garbage Disposal',
    '收废品': 'Waste Collection',
    '待支付': 'Wait Pay',
    '待接单': 'Wait Accept',
    '待服务': 'Wait Service',
    '服务中': 'In Service',
    '已完成': 'Finished',
    '已取消': 'Cancelled',
  },
  '空间': {
    '空间名称': 'Space Name',
    '封面图': 'Cover Image',
    '空间主图': 'Main Image',
    '是否免费': 'Is Free',
    '免费': 'Free',
    '收费': 'Paid',
    '购买价钱': 'Price',
    '空间描述': 'Description',
    '状态': 'Status',
    '启用': 'Enabled',
    '禁用': 'Disabled',
    '排序': 'Sort',
    '基础信息': 'Basic Info',
    '空间门管理': 'Door Management',
    '请上传': 'Please upload',
    '云种植': 'Cloud Plant',
    '商城': 'Mall',
    '直播社区': 'Live Community',
    '短剧': 'Short Drama',
    '需要服务': 'Need Service',
    '提供服务': 'Provide Service',
    '商家维护': 'Merchant',
    '平台维护': 'Platform',
    '门类型': 'Door Type',
    '门图片': 'Door Image',
    '创建时间': 'Create Time',
    '备注': 'Remark',
  },
  '店铺': {
    '店铺等级': 'Shop Level',
  },

  '店铺等级': {
    '等级名称': 'Level Name',
    '等级名称(英文)': 'Level Name (EN)',
    '等级名称(繁体)': 'Level Name (TC)',
    '等级级别': 'Level',
    '服务费': 'Service Fee',
    '平台抽成比例': 'Platform Rate',
    '可发布最大商品数量': 'Max Goods Count',
    '创建时间': 'Create Time',
  },
  '师傅提现': {
    '主键id': 'ID',
    '用户ID': 'User ID',
    '店铺ID': 'Shop ID',
    '师傅信息': 'Worker Info',
    '师傅昵称': 'Worker Nickname',
    '师傅手机号': 'Worker Mobile',
    '提现金额': 'Amount',
    '提现手续费': 'Fee',
    '审核状态': 'Status',
    '未审核': 'Pending',
    '审核未通过': 'Rejected',
    '审核已通过': 'Approved',
    '转账中': 'Transferring',
    '已转账': 'Transferred',
    '提现账号': 'Account',
    '提现账号（支付账号或微信openId或者银行卡号）': 'Account',
    '提现账号姓名': 'Account Name',
    '提现方式': 'Method',
    '支付宝': 'Alipay',
    '微信': 'WeChat',
    '银行卡': 'Bank Card',
    '提现场景': 'Scene',
    '线上自动打款': 'Auto Transfer',
    '线下手动打款': 'Manual Transfer',
    '用户收款码': 'Collection Code',
    '第三方订单号': 'Third Party Order',
    '第三方订单号(微信或支付的交易单号)': 'Third Party Order',
    '失败原因': 'Failure Reason',
    '审核意见': 'Audit Opinion',
    '审核通过': 'Approve',
    '审核拒绝': 'Reject',
    '请填写审核意见': 'Audit opinion is required when rejecting',
    '创建时间': 'Create Time',
    '修改时间': 'Update Time',
    '创建人': 'Creator',
    '修改人': 'Modifier',
    '备注': 'Remark',
  },
  '优惠券类型': {
    '结束时间不能早于开始时间': 'End time cannot be earlier than start time',
    '使用场景': 'Use Scene',
    '商城': 'Mall',
    '上门服务': 'Home Service',
    '领取数量': 'Received Count',
    '已使用数量': 'Used Count',
    '领取明细': 'Receive Details',
    '领取人': 'Receiver',
    '领取人搜索提示': 'Search by nickname or mobile',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '领取时间': 'Receive Time',
    '使用时间': 'Use Time',
    '使用状态': 'Use Status',
  },
  '常见问题解决状态': {
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '问题标题': 'Problem Title',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '解决状态': 'Solve Status',
    '未解决原因': 'Unsolved Reason',
    '创建时间': 'Create Time',
  },
  '抽奖活动奖池配置':{
    'id':'id',
    '名称':'Name',
    '图片':'Picture',
    '奖励类型':'Reward Type',
    '奖励金额':'Reward Amount',
    '中奖概率':'Winning Probability',
    '描述':'Description',
    '创建者':'Creator',
    '创建时间':'Create Time',
    '修改人':'Modifier',
    '更新时间':'Update Time',
    '逻辑删除标记':'Deleted',
    '租户ID，外键{tenant.id}':'Tenant ID',
    '备注':'Remark',
    '版本号':'Version',
    '排序':'Sort',
    '优惠券':'Coupon',
    '中奖概率之和不能超过100':'The sum of winning probabilities cannot exceed 100%. Currently configured {sum}%, this time {current}%',
  },
  '视频评价': {
    '视频编号': 'Video ID',
    '被评价用户': 'Reviewed User',
    '评价用户': 'Commenter',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '评价内容': 'Comment Content',
    '评价状态': 'Status',
    '回复数量': 'Reply Count',
    '审核通过': 'Approved',
    '审核未通过': 'Rejected'
  },
  '查看评论': 'View Comments',
  '实名认证状态': 'Certification Status',
  '未认证': 'Uncertified',
  '已认证': 'Certified',
  '审核中': 'Under Review',
  '审核驳回': 'Rejected',
  '提交审核时间': 'Submit Time',
  '云种植订单': {
    '云种植订单': 'Cloud Planting Order',
    '订单编号': 'Order No.',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '订单类型': 'Order Type',
    '支付状态': 'Payment Status',
    '数量': 'Quantity',
    '面积': 'Area',
    '时长': 'Duration(Days)',
    '单价': 'Unit Price',
    '实付金额': 'Paid Amount',
    '支付时间': 'Payment Time',
    '创建时间': 'Create Time',
    '待支付': 'Unpaid',
    '已支付': 'Paid',
    '已取消': 'Cancelled',
    '购买种子': 'Buy Seeds',
    '购买土地': 'Buy Land',
    '土地续费': 'Land Renewal',
    '购买监控': 'Buy Monitor',
    '监控续费': 'Monitor Renewal',
    '购买操作次数': 'Buy Operation Times'
  },
  '空间订单': {
    '空间订单': 'Space Order',
    '订单编号': 'Order No.',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '空间名称': 'Space Name',
    '订单金额': 'Order Amount',
    '实付金额': 'Paid Amount',
    '支付状态': 'Payment Status',
    '支付时间': 'Payment Time',
    '取消时间': 'Cancel Time',
    '取消原因': 'Cancel Reason',
    '创建时间': 'Create Time',
    '待支付': 'Unpaid',
    '已支付': 'Paid',
    '已取消': 'Cancelled'
  },
  '保证金订单': {
    '保证金订单': 'Deposit Order',
    '订单编号': 'Order No.',
    '用户信息': 'User Info',
    '用户信息搜索提示': 'Search by nickname or mobile',
    '昵称': 'Nickname',
    '手机号': 'Mobile',
    '师傅名称': 'Worker Name',
    '订单类型': 'Order Type',
    '保证金金额': 'Deposit Amount',
    '支付状态': 'Payment Status',
    '支付时间': 'Payment Time',
    '退款状态': 'Refund Status',
    '退款时间': 'Refund Time',
    '退款理由': 'Refund Reason',
    '创建时间': 'Create Time',
    '待支付': 'Unpaid',
    '已支付': 'Paid',
    '已取消': 'Cancelled',
    '未退款': 'Not Refunded',
    '退款中': 'Refunding',
    '已退款': 'Refunded',
    '缴纳保证金': 'Pay Deposit',
    '退回保证金': 'Return Deposit'
  },
  '用户提现': {
    '未审核': 'Pending',
    '审核未通过': 'Rejected',
    '审核已通过': 'Approved',
    '支付宝': 'Alipay',
    '微信': 'WeChat',
    '银行卡': 'Bank Card',
    '提现金额': 'Withdrawal Amount',
    '可提现金额': 'Withdrawable Amount',
    '提现状态': 'Withdrawal Status',
    '提现方式': 'Withdrawal Method',
    '审核意见': 'Audit Opinion',
    '收款码': 'Collection Code',
    '银行名称': 'Bank Name',
    '银行卡号': 'Bank Card Number',
    '开户行': 'Bank Branch',
    '持卡人/收款姓名': 'Cardholder/Payee Name'
  }
};
